'use strict';

var Textfield = require('./Textfield');

/**
 * @constructor
 * @extends Textfield
 */
var Textarea = Textfield.extend('Textarea', {
	/**
	 * @memberof Textarea.prototype
	 * @override Textfield.prototype
	 */
	template: '<textarea lang="{{locale}}" class="hypergrid-textfield" style="{{style}}"></textarea>',

	/**
	 * @memberof Textarea.prototype
	 * @override Textfield.prototype
	 */
	specialKeyups: {
		0x09: 'stopEditing',  // tab
		0x1b: 'cancelEditing' // escape
	},

	/**
	 * @memberOf Textarea.prototype
	 * @desc hide the editor
	 */
	hidEditor: function() {
		this.el.style.display = 'none';
		this.el.removeEventListener('wheel', privateScroll);
	},

	/**
	 * @memberof Textarea.prototype
	 * @override Textfield.prototype
	 * @todo the special keyups do not seem to do the trick, we still get a stop edit when we hit enter
	 * because of cellProps.mappedNavKey(keyChar, e.ctrlKey)
	 */
	keyup: function(e) {
		var keyChar = this.grid.canvas.getKeyChar(e);
		if (keyChar !== 'RETURN') {
			return Textfield.prototype.keyup.apply(this, arguments);
		}
		return false;
	},

	/**
	 * @memberOf Textfield.prototype
	 * @desc display the editor
	 */
	showEditor: function() {
		this.el.style.display = 'inline';
		this.el.addEventListener('wheel', privateScroll);
	}
});

function privateScroll(e) {
	e.stopPropagation();
}

module.exports = Textarea;
